import { render, staticRenderFns } from "./jsonMapper.vue?vue&type=template&id=0a85e456&scoped=true"
import script from "./jsonMapper.vue?vue&type=script&lang=js"
export * from "./jsonMapper.vue?vue&type=script&lang=js"
import style0 from "./jsonMapper.vue?vue&type=style&index=0&id=0a85e456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a85e456",
  null
  
)

export default component.exports